import { useMemo } from "react"
import { useSelector } from "react-redux"
import { StaffCommunity, hasAdminPanel, hasGuardConsole } from "../utils/permissions"


/** Comunidades donde el usuario es parte del equipo, separadas por vista. */
export default function useStaff() {
  const { staff, communities: residentCommunities } = useSelector((state: any) => state.status)

  return useMemo(() => {
    const communities: StaffCommunity[] = staff ?? []
    const adminCommunities = communities.filter(hasAdminPanel)
    const guardCommunities = communities.filter(hasGuardConsole)

    return {
      staff: communities,
      adminCommunities,
      guardCommunities,
      // La consola es la app entera solo si es lo único que tiene (ni panel ni
      // vivienda). Si no, se entra desde Administración (Guard.Stack).
      guardOnly: guardCommunities.length > 0 && adminCommunities.length === 0 && !(residentCommunities?.length > 0),
    }
  }, [staff, residentCommunities])
}
